export enum Metrics {
  ADD_TO_CART = 'AddToCart',
  PURCHASE_INTENT = 'PurchaseIntent',
  FILTER_GOAL = 'FilterGoal',
  LIKE_GOAL = 'LikeGoal',
  VIEW_PRODUCT = 'ViewProduct',
  BEGIN_OFORMLENIE = 'BeginOformlenie',
  COMPARE_GOAL = 'CompareGoal',
  CALL_ME_FORM = 'CallMeForm',
  AUTHORIZATION = 'Authorization',
  GOTO_WB = 'GotoWB',
  GOTO_OZON = 'GotoOzon',
  GOTO_YM = 'GotoYM'
}
